import {
  ActionTypes,
  SetContactAction,
  Contact,
  CreditResponse,
  SetOneTimePasswordAction,
  OneTimePassword,
  CreditFreeze,
  SetCreditFreezeAction,
} from "~/types/contact-credit";
import { ReduxState } from "~/types/redux";
import { Dispatch } from "redux";
import { RecordUnknown } from "~/types/common";
import { setTracking } from "~/redux/actions/common";

interface SetCreditValues {
  type: ActionTypes.SET_CREDIT;
  credit: RecordUnknown;
}

export const setContact = (contact: Contact): SetContactAction => {
  return { type: ActionTypes.SET_CONTACT, contact };
};

export const setCredit = (credit: CreditResponse) => {
  return (dispatch: Dispatch, getState: () => ReduxState): SetCreditValues => {
    const { products } = getState();
    const plan = products?.selected?.internet;

    const is200 = credit?.billingSummary?.lineItems?.find((prod) => prod.displayName === "Fiber 200 Internet");
    const is5G = credit?.billingSummary?.lineItems?.find((prod) => prod.displayName === "Fiber 5 Gig Internet");
    const is7G = credit?.billingSummary?.lineItems?.find((prod) => prod.displayName === "Fiber 7 Gig Internet");

    const routerTypeItems = credit?.billingSummary?.lineItems.filter(({ category }) => category === "Eero");
    if (routerTypeItems?.length > 0) {
      if (is200) {
        routerTypeItems[0].displayName = "eero Pro 6E router";
        routerTypeItems[0].originalAmount = 199.99;
      } else if (is5G) {
        routerTypeItems[0].displayName = "eero Max 7 router";
        routerTypeItems[0].originalAmount = 599.99;
      } else if (is7G) {
        routerTypeItems[0].displayName = "2 eero Max 7 routers";
        routerTypeItems[0].originalAmount = 1149.99;
      }
    }

    const creditData = {
      ...credit,
      billingSummary: {
        ...credit.billingSummary,
        lineItems: (() => {
          const filteredLineItems = (credit?.billingSummary?.lineItems || [])
            .map((lineItem) => {
              const { category, unit, name, displayName } = lineItem;
              const isVisibile = category === "Product" && unit === "MONTHLY";
              const planMatch = plan?.name === name || plan?.name === displayName;

              if (planMatch || !isVisibile) {
                return undefined;
              }

              return lineItem;
            })
            .filter(Boolean);

          return filteredLineItems;
        })(),
        routerType: credit?.billingSummary?.lineItems.filter(({ category }) => category === "Eero") || [],
        plan,
      },
    };

    if (creditData.identityVerification) {
      creditData.identityVerification = creditData.identityVerification.map((data) => {
        return {
          ...data,
          answerChoices: data.answerChoices.map(
            (answer: { text: string; number: string } | { value: string; label: string }) =>
              "text" in answer
                ? { label: answer.text, value: String(answer.number) }
                : { label: answer.label, value: answer.value }
          ),
        };
      });
    }

    if (credit?.accountUuid) {
      dispatch(setTracking("accountUuid", credit.accountUuid));
    }

    dispatch({ type: ActionTypes.SET_CREDIT, credit: creditData });

    return { type: ActionTypes.SET_CREDIT, credit: creditData };
  };
};

export const setOneTimePassword = (otp: OneTimePassword): SetOneTimePasswordAction => {
  return { type: ActionTypes.SET_ONETIMEPASSWORD, otp };
};

export const setCreditFreeze = (creditFreeze: CreditFreeze): SetCreditFreezeAction => {
  return { type: ActionTypes.SET_CREDIT_FREEZE, creditFreeze };
};
